import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";

import MUIDataTable from "mui-datatables";

// components
import PageTitle from "../../components/PageTitle/PageTitle";


// data
import {AccountList} from "./accountsList-api"
//auth
import auth from "../../auth/auth-helper";

const columns = [
  {
   name: "account_no",
   label: "Account No",
   options: {
    filter: true,
    sort: true,
   }
  },
  {
   name: "balance",
   label: "Balance",
  },
  {
    name: "account_status",
    label: "Status",
   },
  {
    name: "branch_name",
    label: "Branch Name",
    options: {
     filter: true,
     sort: false,
    }
   },
  {
   name: "date_created",
   label: "Date created",
  },

 
 ];

export default function Accounts() {
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;
    const credentials = auth.isAuthenticated();

    AccountList(signal,credentials).then((res) => {
      if (res.status === 200) {
        setAccounts(res.response[0]);
        console.log(res);
      } else {
       // console.log('token here .....................'+ credentials);
        // console.log(res.status);
        
        //console.log(res.statusCode);
        console.log(res.error);
      }
     
    });

    return function cleanup() {
      abortController.abort();
    };
  }, []);
  return (
    <>
      <PageTitle title="Accounts" />
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <MUIDataTable
            title="Accounts List"
            data={accounts}
            columns={columns}
            options={{
              filterType: "checkbox",
            }}
          />
        </Grid>
        {/* <Grid item xs={12}>
          <Widget title="Material-UI Table" upperTitle noBodyPadding bodyClass={classes.tableOverflow}>
            <Table data={mock.table} />
          </Widget>
        </Grid> */}
      </Grid>
    </>
  );
}